<script lang="ts" setup>
import AppDefaultDrawer from '~/components/AppDefaultDrawer.vue';
import { useSensitiveInfo } from '~/composables/useSensitiveInfo';
import { SensitiveInfo } from '~/utils/contents/shared/SensitiveInfo';
import SensitiveDocumentsInfo from './SensitiveDocumentsInfo.vue';

const { sensitiveHelpVisible } = useSensitiveInfo();
</script>

<template>
  <AppDefaultDrawer v-model:visible="sensitiveHelpVisible">
    <h1 class="text-color-primary font-title-5">{{ SensitiveInfo.title }}</h1>
    <div class="mt-6">
      <SensitiveDocumentsInfo />
    </div>
  </AppDefaultDrawer>
</template>

<style lang="scss" scoped></style>
